import CreateOrder from "./CreateOrder"

export default  CreateOrder;



// WEBPACK FOOTER //
// ./src/components/App/OrdersManagerDashboard/SubHeader/CreateOrder/index.js